<script lang="ts">
  import { getContext } from 'svelte';
  import clsx from 'clsx';
  import { setContainerContextWidth } from '@athena-lib/container-context.svelte';
  import { getFlexBasisClass, getLeftSpaceClasses, getRightSpaceClasses } from './utils';
  import { contextKey } from './Columns.svelte';
  import type { ColumnsContext, ColumnProps } from './types';
  import { containerWidthFromColumns } from './widths';
  import { getPaddingClassName } from './spacing';

  let {
    children,
    class: className,
    width,
    leftSpace,
    rightSpace,
    action = () => undefined,
    actionArg,
  }: ColumnProps = $props();
  const context = getContext<ColumnsContext>(contextKey);
  const paddingClass = $derived(
    getPaddingClassName(
      context.space(),
      context.collapseBelow(),
      context.collapse(),
      context.reverseWhenCollapsed(),
    ),
  );

  setContainerContextWidth(
    containerWidthFromColumns(
      width,
      context.collapseBelow(),
      context.collapse(),
      context.allWidths(),
    ),
  );

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

{#snippet wrapIfNeeded()}
  {#if leftSpace || rightSpace}
    <div
      class={clsx(
        !context.collapse() && getLeftSpaceClasses(leftSpace, context.collapseBelow()),
        !context.collapse() && getRightSpaceClasses(rightSpace, context.collapseBelow()),
      )}
    >
      {@render children()}
    </div>
  {:else}
    {@render children()}
  {/if}
{/snippet}

<div
  use:elementAction
  class={clsx(
    'w-full min-w-0',
    paddingClass,
    className,
    getFlexBasisClass(width),
    (!width || width === 'auto') && 'flex-grow',
  )}
>
  {@render wrapIfNeeded()}
</div>
